export default __webpack_public_path__ + "static/media/header.7d1dd638.svg";